export default __webpack_public_path__ + "static/blob-25-4e5ecf1b165ce25b9d012bfe7b44a4b0.svg";